var _path, _path2, _line;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVideoCamOffUserList(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2352 5.15674H4.01948C3.543 5.15674 3.15674 5.543 3.15674 6.01948V15.5097C3.15674 15.9862 3.543 16.3724 4.01948 16.3724H15.2352C15.7117 16.3724 16.0979 15.9862 16.0979 15.5097V6.01948C16.0979 5.543 15.7117 5.15674 15.2352 5.15674Z",
    fill: "#d93438",
    stroke: "#d93438",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0002 14.701C23.0002 15.0726 22.609 15.3144 22.2766 15.1482L18.1001 13.0599C17.9307 12.9752 17.8237 12.8021 17.8237 12.6127V8.91703C17.8237 8.72764 17.9307 8.55451 18.1001 8.46981L22.2766 6.38158C22.609 6.21535 23.0002 6.4571 23.0002 6.82879V14.701Z",
    fill: "#d93438",
    stroke: "#d93438",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1.46072,
    y1: 2.57767,
    x2: 17.6781,
    y2: 20.2694,
    stroke: "#d93438",
    strokeWidth: 1.25
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoCamOffUserList);
export default __webpack_public_path__ + "static/media/VideoCamOff-userList.6a7b5e30.svg";
export { ForwardRef as ReactComponent };